import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { MetaDataInfoButton } from "../Buttons/MetaDataInfoButton";
import * as DocumentReader from "../DocumentReader";
import { FullScreen } from "../General/FullScreen";
import { Link } from "../General/Link";
import { Screenfull } from "../Screenfull";
import { DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";

export interface IMetaDataInfoProps {
	fileId: string;
	fullScreen?: FullScreen;
}

@inject("fullScreen")
@observer
export class MetaDataInfoComponent extends React.Component<IMetaDataInfoProps, {}> {

	@observable metas: DocumentReader.ReaderMetaInfo[] = null;

	componentWillMount() {
		this.getInfo(this.props);
	}

	shouldComponentUpdate(nextProps: IMetaDataInfoProps) {
		return nextProps.fileId !== this.props.fileId;
	}

	componentWillUpdate(props: IMetaDataInfoProps) {
		this.getInfo(props);
	}

	getInfo(props: IMetaDataInfoProps) {
		DocumentReader.getDocumentMetasAsync(props.fileId)
			.then(result => {
				this.metas = result;
			})
			.catch(error => DialogStore.showError(Strings.general.errorDialogTitle, error));
	}

	onClick = () => {
		if (this.props.fullScreen && Screenfull.element) {
			this.props.fullScreen.toggleFullScreen();
		}
		let content = <table className="metaInfoBoxContent">
			<tbody>
				{this.metas.map((meta, i) => {
					return <tr key={i}>
						<td key="caption">{meta.caption}</td>
						<td key="value">
							{meta.values.map((value, i) => {
								if (meta.linkTargets.length > 0) {
									let linkTarget = meta.linkTargets[i];
									return <Link to={Urls.reader + "/" + linkTarget} onClick={() => DialogStore.open = false} className="link-document info">
										<span>{value}</span>
									</Link>;
								}
								else {
									return i > 0 ? <><br />{value}</> : value;
								}
							})}
						</td>
					</tr>
				})}
			</tbody>
		</table>;
		DialogStore.showContent(Strings.reader.metaInfoBoxTitle, content);
	}

	render() {
		return <MetaDataInfoButton onClick={this.onClick} />;
	}
}
